import { useId } from "react";
import { Source, SOURCE_CODE_TO_LABEL } from "@/constants";
import { useI18n } from "@/contexts/i18nContext";
import { Progress } from "@/components/ui/progress";
import { i18n } from "@lingui/core";

export default function ChannelTypeShare({
  source,
  share,
}: {
  source: Source;
  share: number;
}) {
  const { formatPercent } = useI18n();
  const labelId = useId();

  return (
    <div className="flex items-center py-2 first:pt-0 last:pb-0 gap-2.5">
      <p id={labelId} className="flex-1 truncate text-muted-foreground text-sm">
        {i18n._(SOURCE_CODE_TO_LABEL[source])}
      </p>
      <Progress
        aria-labelledby={labelId}
        className="flex-1"
        value={share * 100}
      />
      <p className="text-sm text-center font-medium min-w-14">
        {formatPercent(share, 0)}
      </p>
    </div>
  );
}
